var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1a3e4f;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.1,272.8c-7.1,4.9-22.7,26.9-27.1,33.1c-20.9,20.8-53.7,40.4-74.8,56.1c-10.5,8.5-29,26.8-43.3,25.2 c-35.8-1.8-66.9-26.3-105.1-28.3c-83.7-3.5-27.2,36.6-106.4-68.5c100.4-95,155.3,5.5,249.1-10c23.6-2.8,39.4-5.1,58,8.2 c10.5,11.3,2.3,26.1-13.2,30c-9.5,6.1-128.5-3.3-112.8,5.8c42.6,3,68.2,0.2,102.2,0c3.2,0,11.8-0.1,20.4-5 c15.4-6.2,18.9-33,1.2-37.6c-1.2-2.7,6.8-8.5,12.3-12.8c13.7-10.1,15.4-17.6,38.2-29.9C477.6,223.2,452.3,257.8,438.1,272.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.3,224c20.9-5.2,4,6.1-4.5,13.7c-10.6,9-27.1,26-36.3,32.6c-3.4,5.7-7.8,8.8-14.8,7.3 c6.2-11.5,20.3-21,29.9-30.7C396.4,241.4,411,225.2,416.3,224z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.5,249c6.6-6.3,52.7-54.1,47.9-16.5c-18.8-6.1-52.6,32.2-64.8,42.2c-7.2,7.9-3.7,5.6-14.5,3.2 C379.4,267.5,398.4,255.7,404.5,249z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.5,231.3c2.6-1.3,5.2-3.2,4.7-0.9c-9.1,9.1-25.5,25.4-35.7,33.5c-7,5.9-8.7,16.5-19.1,12.9 c6.9-12,19.2-19.4,27-26.7C388,241,386.9,237,399.5,231.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181,135.2c-14.8-35.9,11.8-72.4,47.4-70.3c26.7,1.9,37,15.1,53.8,30.1c3.8,3.5,36.7-36.6,70-28.6 c25.9,4.1,37.1,35.2,35.3,50.5c-9.2,60.1-65.4,84.6-104.8,134.7C259.5,222.1,191.8,168,181,135.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.2,390.7c-6.9,12.1-7.9,14.2-9.6,14.1c-29.6-25.7-48.3-70-68-110.4c25.8-32.4,59.7,53.4,75.9,67.3 C144.4,377.9,141.5,368.5,129.2,390.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateIcon);
export default __webpack_public_path__ + "static/media/donate-icon.a877c2ef92261b1dc1605725a634f29f.svg";
export { ForwardRef as ReactComponent };